/**
 * Messages are now schema-derived and read-only.
 * Delete functionality is no longer available.
 * This component is retained as a no-op for import compatibility.
 */
function MessageDeleteModal() {
  return null;
}

export default MessageDeleteModal;
